import axios from "axios"
import type { HttpAdapter } from "../../core/adapters/axios.adapter"
import type { AttendeesResult, EventAttendeesResponse } from "../models/attendee.models"

export class EventAttendeesService {
  constructor(private httpAdapter: HttpAdapter) {}

  async getAttendees(eventSlug: string): Promise<AttendeesResult> {
    try {
      const url = `events/${encodeURIComponent(eventSlug)}/attendees`
      const response = await this.httpAdapter.get<EventAttendeesResponse>(url)
      return { status: "ok", attendees: response.data.attendees ?? [] }
    } catch (error) {
      // 403 = authenticated but not an approved guest of this event.
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        return { status: "forbidden" }
      }
      console.error("[EventAttendees] fetch failed", error)
      return { status: "error" }
    }
  }

  /** Absolute URL to the CSV download endpoint (auth header is added by the
   *  axios adapter when fetched; for a direct <a download> the browser won't
   *  send the Bearer token, so the component fetches the blob via the adapter). */
  csvPath(eventSlug: string): string {
    return `events/${encodeURIComponent(eventSlug)}/attendees.csv`
  }

  async getAttendeesCsvBlob(eventSlug: string): Promise<Blob | null> {
    try {
      const response = await this.httpAdapter.get(this.csvPath(eventSlug), { responseType: "blob" })
      if (response.status < 200 || response.status >= 300) return null
      return response.data as Blob
    } catch (error) {
      console.error("[EventAttendees] CSV fetch failed", error)
      return null
    }
  }
}
